"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMultiSelectChangePayload = void 0;
var _lodash = require("lodash");
const getMultiSelectChangePayload = selectedOptions =>
// @ts-ignore ignore generic typing error
(0, _lodash.isNil)(selectedOptions) ? [] : selectedOptions.map(_ref => {
  let {
    value
  } = _ref;
  return value;
});
exports.getMultiSelectChangePayload = getMultiSelectChangePayload;
//# sourceMappingURL=multiSelectHelpers.js.map